package services

fun nowIso(): String = js("new Date().toISOString()") as String
